module.exports = __webpack_public_path__ + "static/media/BannerAcDP.42d26443.svg";